export const lowerCase = (string = '') => string.toLowerCase()
